<script lang="ts">
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import arrow from './arrow.svg'

    export let selectedNetwork
    export let selectedCurrency

    let networkDropdownOpen = false

    function openDropdown() {
        if (['DRAG', 'USDT'].includes(selectedCurrency)) {
            networkDropdownOpen = !networkDropdownOpen
        }
    }

    function changeNetwork(network) {
        selectedNetwork = network
        networkDropdownOpen = false
    }
</script>

<div class="form-group mb-4">
    <label class="mb-2 w-100">Network</label>
    <div class="dropdown" use:clickOutside={() => {networkDropdownOpen = false}}
         class:active={networkDropdownOpen}
         class:disabled={!['DRAG', 'USDT'].includes(selectedCurrency)}>
        <div class="dropdown-selected">
            <div class="need-select notranslate" on:click={openDropdown}>
                {selectedNetwork}<img src="{arrow}" class="arrow" alt="">
            </div>
        </div>
        <div class="dropdown-list">
            <div class="item notranslate" on:click={() => changeNetwork('BNB Chain')}>
                BNB Chain
            </div>
        </div>
    </div>
</div>

<style>
    .dropdown {
        background: #343168;
        border-radius: 6px;
        position: relative;
        z-index: 4;
    }

    .dropdown.active {
        z-index: 5;
    }

    .dropdown.disabled {
        opacity: 0.6;
    }

    .dropdown.disabled .dropdown-selected {
        cursor: default;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 16px;
        color: white;
        font-weight: 500;
        border: 1px solid #CAD5E0;
        border-radius: 6px;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 12px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 14px 16px;
        height: 46px;
        margin: -10px;
        font-weight: 400;
    }

    .dropdown-list {
        display: none;
        padding: 10px 20px;
        position: absolute;
        background: #343168;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #CAD5E0;
        margin-top: 10px;
        z-index: 2;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .item {
        font-size: 16px;
        color: white;
        padding: 12px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .item:not(:last-child) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .dropdown-list .item:hover {
        color: #cbcaca;
    }

    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    @media(max-width: 767px) {
        .dropdown-selected {
            font-size: 16px;
        }
    }
</style>
